import { NavLink } from 'react-router-dom';
import React from 'react';
import Moment from 'moment';
import { isEmpty } from 'helpers/helpers';
import ProductionTagsFilter from 'components/ProductionTagsFilter/ProductionTagsFilter';

import DateFilter from '../../../components/Grid/Filter/Date';
import SelectFilter from '../../../components/DataGrid/Filter/SelectFilter';

const columnsConfig = ({ t, mealTypes = [], displayedDate }) => {
  // eslint-disable-next-line new-cap -- FIXME
  const now = Moment(displayedDate).set({ hour: 0, minute: 0 });
  const config = [
    {
      accessor: 'id',
      name: 'id',
      width: 50,
      sortable: true,
    },
    {
      name: 'nameForClient',
      accessor: 'nameForClient',
      sortable: true,
    },
    {
      name: 'workingName',
      accessor: 'workingName',
      sortable: true,
      filterable: true,
      extractFiltersByComma: false,
    },
    {
      name: 'ingredientName',
      accessor: row =>
        row.components
          .map(component =>
            component.recipe
              ? component.recipe.workName
              : (component.ingredient && component.ingredient.name) || false
          )
          .filter(Boolean)
          .join(', '),
      sortable: false,
    },
    {
      name: 'allergens',
      accessor: row =>
        row.allergens
          .map(({ value = false }) => value)
          .filter(Boolean)
          .join(', '),
      sortable: false,
    },
    {
      name: 'tagsForProduction',
      accessor: row => row.tags.map(el => el.value).join(', '),
      sortable: false,
      filterable: true,
      extractFiltersByComma: false,
      Filter: ProductionTagsFilter,
    },
    {
      name: 'lastUsedDate',
      accessor: row => {
        let latestUsage = null;

        if (row.menuPlannerInfo.latestUsage) {
          // eslint-disable-next-line new-cap -- FIXME
          latestUsage = Moment(row.menuPlannerInfo.latestUsage);
        }
        // eslint-disable-next-line no-nested-ternary -- FIXME
        return latestUsage
          ? latestUsage.isSame(now)
            ? t('common.shared.today')
            : latestUsage.from(now)
          : '';
      },
      Filter: ({ onChange, filter }) => (
        <DateFilter onChange={onChange} value={filter?.value} />
      ),
      sortable: true,
      filterable: true,
      extractFiltersByComma: false,
    },
    {
      name: 'featureUsedDate',
      accessor: row => {
        let featureUsage = null;

        if (row.menuPlannerInfo.featureUsage) {
          // eslint-disable-next-line new-cap -- FIXME
          featureUsage = Moment(row.menuPlannerInfo.featureUsage);
        }
        // eslint-disable-next-line no-nested-ternary -- FIXME
        return featureUsage
          ? featureUsage.isSame(now)
            ? t('common.shared.today')
            : featureUsage.from(now)
          : '';
      },
      Filter: ({ onChange, filter }) => (
        <DateFilter onChange={onChange} value={filter?.value} />
      ),
      sortable: true,
      filterable: true,
      extractFiltersByComma: false,
    },
    {
      name: 'servingSuggestion',
      accessor: 'servingSuggestion.value',
      sortable: true,
    },
    {
      name: 'types',
      accessor: row => row.types.map(el => el.name).join(', '),
      ...(mealTypes?.length > 6
        ? { filterable: true }
        : {
            Filter: ({ onChange, filter }) => {
              // eslint-disable-next-line no-negated-condition -- FIXME
              const options = !isEmpty(mealTypes)
                ? mealTypes.map(mealType => ({
                    '@id': mealType,
                    name: mealType,
                  }))
                : [];

              return (
                <SelectFilter
                  options={options}
                  value={filter?.value ?? []}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          }),
      sortable: true,
      extractFiltersByComma: false,
    },
    {
      name: 'rate',
      // eslint-disable-next-line no-negated-condition -- FIXME
      accessor: row => (row.rateAVG !== null ? row.rateAVG.toFixed(2) : '-'),
      filterable: false,
      sortable: true,
    },
    {
      name: 'actions',
      accessor: row => (
        <NavLink to={`/admin/meals/edit/${row.id}`}>
          {t('menuPlanner.dishesGrid.goToDish')}
        </NavLink>
      ),
      filterable: false,
      sortable: false,
    },
  ];

  return config.map(row => {
    row.title = t(`menuPlanner.dishesGrid.columns.${row.name}`);

    return row;
  });
};

export default columnsConfig;
